// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2NFYd","head":"Table_head__2dwOv","col":"Table_col__2Wev8"};